import { useCallback, useEffect, useMemo, useState } from 'react';
import { getNewLaunchesCourses } from '../services/courses';
import { mapNewLaunchCourse } from '../utils/dashboardMappers';

export function useNewLaunchesCourses(params = {}) {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const paramsKey = useMemo(() => JSON.stringify(params), [params]);

  const fetchCourses = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const parsedParams = paramsKey ? JSON.parse(paramsKey) : {};
      const res = await getNewLaunchesCourses(parsedParams);
      const list = (res?.data?.courses || []).map(mapNewLaunchCourse).filter(Boolean);
      setCourses(list);
    } catch (e) {
      setError(e?.message || 'Failed to load new courses');
      setCourses([]);
    } finally {
      setLoading(false);
    }
  }, [paramsKey]);

  useEffect(() => {
    fetchCourses();
  }, [fetchCourses]);

  return { courses, loading, error, refetch: fetchCourses };
}
